import React from 'react';
import PROXI_BRAIN_LOGO from '@/ui/assets/images/proxivideobrainlogo.png';
import { LightShell, LightMark } from '../light-ui';

interface CheckInUnavailableProps {
  message?: string;
  /** Lets someone signed in to a different account switch to the right one. */
  onSignOut?: () => void;
}

/** Shown when a check-in SMS link doesn't resolve for the signed-in user. */
const CheckInUnavailable: React.FC<CheckInUnavailableProps> = ({ message, onSignOut }) => {
  return (
    <LightShell scroll>
      <main
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          padding: 'clamp(28px, 8vh, 72px) clamp(20px, 6vw, 80px)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 22, textAlign: 'center', maxWidth: 540 }}>
          <LightMark src={PROXI_BRAIN_LOGO} size={80} />

          <span className="lp-frost-chip">Check-in</span>

          <h1 className="lp-section-heading" style={{ fontSize: 'clamp(28px, 5vw, 42px)' }}>
            This check-in isn't available.
          </h1>

          <div className="lp-prose" style={{ maxWidth: 460 }}>
            <p>{message || "We couldn't open this check-in. Open the latest check-in text to answer it."}</p>
          </div>

          <button
            type="button"
            onClick={() => { window.location.href = '/'; }}
            className="lp-btn lp-btn-primary"
            style={{ marginTop: 4, minWidth: 260 }}
          >
            See my interviews
          </button>

          {onSignOut && (
            <button type="button" onClick={onSignOut} className="lp-btn-link">
              Not your check-in? Sign in with a different account
            </button>
          )}
        </div>
      </main>
    </LightShell>
  );
};

export default CheckInUnavailable;
